export default function getLayout() {
    let gridElement = null;
    let showSort = false;

    function initializeLayout() {
        gridElement = document.querySelector('.grid');
    }

    function displayMapView() {
        gridElement.classList.add('map-grid-container');
        gridElement.classList.remove('filters-grid-container');
        window.dispatchEvent(new Event('mapViewDisplayed'));
    }

    function displayListView() {
        gridElement.classList.add('filters-grid-container');
        gridElement.classList.remove('map-grid-container');
        window.dispatchEvent(new Event('listViewDisplayed'));
    }

    function displaySort() {
        showSort = !showSort;
    }

    function stickFiltersControls(event) {
        let filtersContent = event.target;

        gridElement.classList.add('sticky');

        if (filtersContent.scrollTop === 0) {
            gridElement.classList.remove('sticky');
        }
    }

    return {
        initializeLayout,
        displayMapView,
        displayListView,
        displaySort,
        stickFiltersControls,
        showSort,
    };
}
